<template>
        <!--<div id="printArea" ref="printContent">
            <div class="content">
                <div class="page page1" style="page-break-after:always">
                    <h1 class="row1" style="margin-top:100px;text-align:center;width:70%;
                    font-size:28px;
                    font-weight:bold;">非道路柴油移动机械和车载柴油机设备</h1>
                    <h1 class="row1" style="text-align:center;width:70%;
                    font-size:28px;
                    font-weight:bold;">排气烟度</h1>
                    <div class="row2">检验报告</div>

                    <div class="row3" style="margin-top:300px;">报&nbsp;&nbsp;告&nbsp;&nbsp;编&nbsp;&nbsp;号 ：<div class="val">{{this.dataSource.reportNo}}</div></div>
                    <div class="row3">委&nbsp;&nbsp;托&nbsp;&nbsp;单&nbsp;&nbsp;位 ：<div class="val">{{this.dataSource.department&&this.dataSource.department.departmentName}}</div></div>
                    <div class="row3">设&nbsp;&nbsp;备&nbsp;&nbsp;名&nbsp;&nbsp;称 ：<div class="val">{{this.dataSource.archiveInfo&&this.dataSource.archiveInfo.equipmentType&&this.dataSource.archiveInfo.equipmentType.typeName}}</div></div>
                    <div class="row3">检&nbsp;&nbsp;验&nbsp;&nbsp;类&nbsp;&nbsp;型 ：<div class="val">{{this.dataSource.assayType&&this.dataSource.assayType==1?'尾气复检':'新检测'}}</div></div>

                    <div class="row4" style="margin-top:300px;">检测单位:{{this.dataSource.department&&this.dataSource.department.departmentName}}</div>
                    <div class="row4">地址:{{this.dataSource.department&&this.dataSource.department.address}}</div>
                    <div class="row4"><span>联系人:{{this.dataSource.department&&this.dataSource.department.contacter}}</span><span style="margin-left:100px;">手机:{{this.dataSource.department&&this.dataSource.department.mobile}}</span></div>
                </div>

                <div class="page page2" style="page-break-after:always">
                    <div class="table-body">
                        <h1>非道路柴油移动机械排气烟度检验报告</h1>
                        <div class="table-body-main">
                            <table class="table-row">
                                <tr><td colspan="4" style="font-weight: bold;text-align: left;">1.非道路柴油移动机械和车载柴油机基本信息</td></tr>
                                <tr><td width="20%">机械类型</td><td width="20%">{{this.dataSource.archiveInfo&&this.dataSource.archiveInfo.equipmentType&&this.dataSource.archiveInfo.equipmentType.typeName}}</td>
                                    <td width="20%">发动机制造厂名称</td><td width="40%">{{this.dataSource.archiveInfo&&this.dataSource.archiveInfo.engineFactoryName}}</td></tr>
                                <tr><td>机械型号</td><td>{{this.dataSource.archiveInfo&&this.dataSource.archiveInfo.typeName}}</td><td>发动机型号</td><td>{{this.dataSource.archiveInfo&&this.dataSource.archiveInfo.engineType}}</td></tr>
                                <tr><td>机械编码/机械环保码</td><td>{{this.dataSource.archiveInfo&&this.dataSource.archiveInfo.epNo}}</td><td>发动机额定净功率（kW）</td><td>{{this.dataSource.archiveInfo?(this.dataSource.archiveInfo.engineRatedPower||''):''}}</td></tr>
                                <tr><td>排放阶段</td><td>{{this.dataSource.archiveInfo&&(this.dataSource.archiveInfo.emissionStandards==0?'电动':('国'+this.dataSource.archiveInfo.emissionStandards))}}</td><td>发动机额定转速（r/min）</td>
                                    <td>{{this.dataSource.archiveInfo?(this.dataSource.archiveInfo.engineRatedSpeed||''):''}}</td></tr>
                                <tr><td>出厂年份</td><td>{{this.dataSource.archiveInfo&&this.dataSource.archiveInfo.productionDate}}</td><td>发动机后处理类型</td><td>{{afName()}}</td></tr>
                                <tr><td>生产厂名称</td><td colspan="3" style="text-align:left;">{{this.dataSource.archiveInfo&&this.dataSource.archiveInfo.factoryName}}</td></tr>
                                <tr><td colspan="4" style="font-weight: bold;text-align: left;">2.所有人或代理人信息</td></tr>
                                <tr><td>姓名/单位</td><td colspan="3" style="text-align:left;">{{this.dataSource.archiveInfo&&this.dataSource.archiveInfo.ownerName}}</td></tr>
                                <tr><td>联系电话</td><td>{{this.dataSource.archiveInfo&&this.dataSource.archiveInfo.ownerContact}}</td><td>联系地址</td><td></td></tr>
                                <tr><td colspan="4" style="font-weight: bold;text-align: left;">3.检测设备信息</td></tr>
                                <tr><td>不透光烟度计</td><td style="text-align:left;border-right:none;">型号：{{this.dataSource.opacimeterType}}</td><td style="text-align:left;border-left:none;border-right:none;">编号：{{this.dataSource.opacimeterNo}}</td><td style="text-align:left;border-left:none;">厂家：{{this.dataSource.opacimeterManu}}</td></tr>
                                <tr><td>转速分析仪</td><td style="text-align:left;border-right:none;">型号：</td><td style="text-align:left;border-left:none;border-right:none;">编号：</td><td style="text-align:left;border-left:none;">厂家：</td></tr>
                                <tr><td>滤光片</td><td style="text-align:left;border-right:none;">型号：</td><td style="text-align:left;border-left:none;border-right:none;">编号：</td><td style="text-align:left;border-left:none;">厂家：</td></tr>
                                <tr><td>计时器</td><td style="text-align:left;border-right:none;">型号：</td><td style="text-align:left;border-left:none;border-right:none;">编号：</td><td style="text-align:left;border-left:none;">厂家：</td></tr>
                            </table>
                            <div class="table-c">
                                <table class="table-row">
                                    <tr><td colspan="4" style="font-weight: bold;text-align: left;">4.检测环境</td></tr>
                                    <tr><td width="20%">环境温度(℃)</td><td width="20%">{{this.dataSource.temperature?(this.dataSource.temperature+'℃'):''}}</td>
                                        <td width="30%">环境湿度（RH）</td><td width="30%">{{this.dataSource.humidity?(this.dataSource.humidity+'％'):''}}</td></tr>
                                </table>
                            </div>
                            <div class="table-c">
                                <table class="table-row">
                                    <tr><td colspan="8" style="font-weight: bold;text-align: left;">5.排气烟度检验</td></tr>
                                    <tr><td width="20%" rowspan="3">烟度检验结果（m-1）</td><td colspan="3">三次烟度测量值（m-1）</td><td>最大值（m-1）</td><td>平均值（m-1）</td><td>限值（m-1）</td><td>转速(r/min)</td></tr>
                                    <tr><td>1</td><td>2</td><td>4</td><td rowspan="2">{{maxSmoke()}}</td><td rowspan="2">{{this.dataSource.smokeVal}}</td><td rowspan="2">0.5</td><td rowspan="2"></td></tr>
                                    <tr><td>{{this.dataSource.smokeVal1}}</td><td>{{this.dataSource.smokeVal2}}</td><td>{{this.dataSource.smokeVal3}}</td></tr>
                                    <tr><td>检验结论</td><td colspan="7" style="text-align: left;">合格<template v-if="this.dataSource.status==0">☑</template><span style="margin-left:100px;">不合格<template v-if="this.dataSource.status==1">☑</template></span> </td></tr>
                                    <tr><td>检验日期</td><td colspan="7" style="text-align: left;">{{this.dataSource.examDate}}</td></tr>
                                    <tr><td>检验地点</td><td colspan="7" style="text-align: left;">{{this.dataSource.examAddress}}</td></tr>
                                    <tr><td>检验方法</td><td colspan="7" style="text-align: left;">自由加载<template v-if="this.dataSource.examMethod==1">☑</template><span style="margin-left:100px;">自由加速<template v-if="this.dataSource.status==0">☑</template></span></td></tr>
                                    <tr><td>检验次数及时间</td><td colspan="7" style="text-align: left;">检验次数：三次<span style="margin-left:100px;">检验时间：三分钟</span></td></tr>
                                    <tr><td>检验开始时间</td><td colspan="7" style="text-align: left;">{{startTime(this.dataSource.addTime)}}</td></tr>
                                    <tr><td>检验结束时间</td><td colspan="7" style="text-align: left;">{{endTime(this.dataSource.addTime)}}</td></tr>
                                </table>
                            </div>
                            <div class="table-c">
                                <table class="table-row">
                                    <tr><td colspan="4" style="font-weight: bold;text-align: left;">6.检验单位信息</td></tr>
                                    <tr><td width="20%">单位名称</td><td colspan="3">{{this.dataSource.department&&(this.dataSource.department.departmentName+'/联系电话:'+this.dataSource.department.mobile)}}</td></tr>
                                    <tr><td>联系地址</td><td colspan="3">{{this.dataSource.examAddress||''}}</td></tr>
                                    <tr><td>检验人员</td><td colspan="3"></td></tr>
                                    <tr><td>审核人员</td><td></td><td width="20%">批准人员</td><td></td></tr>
                                    <tr><td>检验依据</td><td colspan="3" style="text-align:left;">《非道路柴油移动机械排气烟度值及测量方法》GB36886-2018<br>
                                        《柴油车污染物排放限值及测量方法（自由加速法及加载减速法）》GB3847-2018</td></tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="page page3" style="page-break-after:always">
                    <h1 style="width:100%;text-align: center;">非道路柴油移动机械和车载柴油机</h1>
                    <h1 style="width:100%;text-align: center;">整机及排放相关部件照片</h1>
                    <h3 style="margin:5mm 0;">一、机械照片</h3>
                    <img v-if="this.dataSource.pic1" :src="'/supervise'+this.dataSource.pic1" />
                    <div v-else></div>
                    <h3 style="margin:5mm 0;">一、铭牌照片</h3>
                    <img v-if="this.dataSource.pic2" :src="'/supervise'+this.dataSource.pic2" />
                    <div v-else></div>
                    <h3 style="margin:5mm 0;">一、其他照片</h3>
                    <img v-if="this.dataSource.pic3" :src="'/supervise'+this.dataSource.pic3" />
                </div>
            </div>
        </div>-->
    <div>
        <div>我是第一页</div>
        <div style="page-break-after: always"></div>
        <div style="page-break-after: always;margin-top:290mm;">我是第二页</div>
        <div style="page-break-after: always">我是第三页</div>
    </div>
</template>

<script>
    import modalHelper from "@/mixins/modalHelper";
    import iEquip from '@/module/main/api/iEquip';
    import _don from "@/libs/doson";

    const formModal = {
        id:null,
        reportNo:null,
        reportUuid:null,
        department:{id:null},
        equipmentId:null,
        archiveInfo:null,
        assayType:0,
        perfermance:0,
        highDis:0,
        opacimeterType:null,
        opacimeterNo:null,
        opacimeterManu:null,
        timerType:null,
        timerNo:null,
        timerManu:null,
        vsaType:null,
        vsaNo:null,
        vsaManu:null,
        lightfilterType:null,
        lightfilterNo:null,
        lightfilterManu:null,
        temperature:null,
        elevation:null,
        pressure:null,
        humidity:null,
        examMethod:0,
        smokeVal1:null,
        smokeVal2:null,
        smokeVal3:null,
        smokeVal:null,
        pic1:null,
        pic2:null,
        pic3:null,
        examDate:null,
        expireDate:null,
        examAddress:null,
        status:0
    };

    export default {
        name: "report-print",
        mixins: [],
        components: {
        },

        data() {
            return {
                dataSource:{}
            }
        },
        mounted() {

        },
        activated() {
            console.log(this.$route.query.id)
        },
        methods: {
            init() {

            },
            setFormData() {
                _don.cloneWithModal(formModal, this.formData, this.dataSource);
            },
            maxSmoke() {
                if (!this.dataSource.smokeVal) {
                    return ''
                }
                return Math.max(this.dataSource.smokeVal1,this.dataSource.smokeVal2,this.dataSource.smokeVal3)
            },
            afName() {
                if (!this.dataSource.archiveInfo || !this.dataSource.archiveInfo.afterProcess) {
                    return '无'
                }
                //0=无 1=SCR 2=DPF 3=POC 4=DOC
                let af = this.dataSource.archiveInfo.afterProcess;
                return ['无','SCR','DPF','POC','DOC'][af]
            },
            startTime(end) {
                if (end) {
                    return this.formatDate(new Date(new Date(end).getTime()-3*60*1000), 'hh:mm:ss')
                }
            },
            endTime(end) {
                if (end) {
                    return this.formatDate(new Date(end), 'hh:mm:ss')
                }
            },
            formatDate(date, fmt) {
                if (/(y+)/.test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
                }
                let o = {
                    'M+': date.getMonth() + 1,
                    'd+': date.getDate(),
                    'h+': date.getHours(),
                    'm+': date.getMinutes(),
                    's+': date.getSeconds()
                };
                for (let k in o) {
                    if (new RegExp(`(${k})`).test(fmt)) {
                        let str = o[k] + '';
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
                    }
                }
                return fmt;
            },
            myPrint() {
                var newWin= window.open("");//新打开一个空窗口
                newWin.document.body.innerHTML = this.$refs.printContent.innerHTML;
                newWin.document.close();//在IE浏览器中使用必须添加这一句
                newWin.focus();//在IE浏览器中使用必须添加这一句
                newWin.print();//打印
                newWin.close();
            }
        },
        computed: {

        },
        watch:{

        }
    }
</script>

<style scoped lang="less">
    #printArea{
        width:210mm;
        /*height:891mm;*/

        .content{
            padding:0 5mm;

            .page{
                width:100%;
                height:297mm;
                display: flex;
                flex-direction: column;
                align-items: center;
                font-family: 宋体;
                color:#000000;

                div{
                    box-sizing: border-box;
                }
            }

            .page1{
                .row1{
                    width:70%;
                    font-size:28px;
                    font-weight:bold;
                }
                .row2{
                    font-size:48px;
                    font-family: 黑体;
                }

                .row3{
                    width:80%;
                    padding-right:10%;
                    font-size:18px;
                    display: flex;

                    .val{
                        flex:1;
                        border-bottom:1px solid #000000;
                    }
                }

                .row4{
                    width:70%;
                    font-size:14px;
                    font-weight: bold;
                    line-height:21px;
                }
            }

            .page2{
                .table-body {
                    padding-top: 20px;
                    width:96%;
                }
                .table-body h1 {
                    font-size: 24px;
                    text-align: center;
                }
                .table-row td {
                    border: 1.5px solid #000000;
                    text-align: center;
                    padding: 5px;
                    border-top: none;
                }
                .table-row {
                    border-collapse: collapse;
                    border: 1.5px solid #000000;
                    width: 100%;
                    border: none;
                }
                .table-body-main {
                    margin-top: 20px;
                }
                .table-body-main > .table-row:first-child {
                    border-top: 1.5px solid #000000;
                }
                .table-c {
                    margin-top: -1px;
                }

            }

            .page3{
                padding:5mm;
                align-items: flex-start;

                h3{
                    font-weight: normal;
                }
                img{
                    height:70mm;
                }
                div{
                    height:70mm;
                }
            }
        }


    }
</style>
